<div class="my-5">
  <sm-page-header [breadcrumb]="breadcrumb" title="settings.committee.pages.conselliers_history"> </sm-page-header>
  <div class="content">
    <div class="flex items-center gap-2">
        <sm-form-builder [formObject]="formObject"></sm-form-builder>
        <p-button
            [label]="'settings.committee.history.search' | translate"
            (click)="confirm()"
            class="mt-11"
            [disabled]="isSearchDisabled$ | async"
        ></p-button>
    </div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
  </div>
</div>
